import { render, staticRenderFns } from "./LoadingBox.vue?vue&type=template&id=0f1dc60d&scoped=true"
import script from "./LoadingBox.vue?vue&type=script&lang=js"
export * from "./LoadingBox.vue?vue&type=script&lang=js"
import style0 from "./LoadingBox.vue?vue&type=style&index=0&id=0f1dc60d&prod&lang=css"
import style1 from "./LoadingBox.vue?vue&type=style&index=1&id=0f1dc60d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f1dc60d",
  null
  
)

export default component.exports